import React, { Component, Fragment } from 'react';
import Summary from './Summary';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { m, capitalize } from '../../utils';
import Loading from '../shared/Loading';
import { Redirect } from 'react-router-dom';

class PaymentsContainer extends Component {
  onClick = () => {};

  render() {
    const { periodStart, currentUser, latestStatementStart, highestPaycheck } = this.props;
    const isLatestStatement = false;
    return (
      <Fragment>
        <Query
          query={gql`
            query Statement($periodStart: String!) {
              payStatement(periodStart: $periodStart) {
                earnings
                ccCharges
                viaCollections
                totalPaid
                payout
                paidOut
                balance
                cumulativeBalance
                broughtForward
                outstandingBalance
                deductions
                credits
                promos
                fees
                totalOwed
                uberHst
                autzuHst
                bookingHst
                period
                deductionHst
                creditHst
                proHours
                plusHours
                realTimeBalance
                ccChargeDetails(periodStart: $periodStart) {
                  amount
                  description
                  transactionTime
                }
                bookingFeeDetails(periodStart: $periodStart) {
                  amount
                  source {
                    ... on Booking {
                      startTime
                      endTime
                      vehicleClass
                    }
                  }
                }
                creditDetails(periodStart: $periodStart) {
                  amount
                  transactionTime
                  description
                }
                promoDetails(periodStart: $periodStart) {
                  amount
                  transactionTime
                  description
                }
                deductionDetails(periodStart: $periodStart) {
                  amount
                  transactionTime
                  description
                }
              }
            }
          `}
          variables={{ periodStart }}>
          {({ loading, error, data }) => {
            if (loading) return <Loading size="3x" />;
            if (error) return <Redirect to="/404" />;
            return (
              <div className="payments__single-payment--body">
                <Summary
                  currentUser={currentUser}
                  latestStatement={data.payStatement}
                  isLatestStatement={isLatestStatement}
                  highestPaycheck={highestPaycheck}
                />
                <div className="payments__single-payment">
                  <div className="panel-group payments__single-payment--container" id="accordion1">
                    <div className="payments__single-payment--header">
                      <div className="payments__single-payment--header-title">
                        <div className="payments__single-payment--first-column"> Category </div>
                        {currentUser.operatingCity === "toronto" ? <div className="static payments__single-payment--second-column">HST</div> : null}
                        <div className="payments__single-payment--third-column">Total</div>
                      </div>
                    </div>

                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a>Trip Earnings</a>
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column">{`$${data.payStatement.uberHst.toFixed(
                          2
                        )}`}</div> : null}
                        <div className="payments__single-payment--third-column">{currentUser.operatingCity === "toronto" ? `$${data.payStatement.earnings.toFixed(
                          2
                        )}` : "N/A"}</div>
                      </div>
                    </div>
                    
                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a data-toggle="collapse" data-parent="#accordion1" href="#collapseTwo">
                            Booking Fees<span className="caret" />
                          </a>
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column">{`$${data.payStatement.bookingHst.toFixed(
                          2
                        )}`}</div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.fees.toFixed(
                          2
                        )}`}</div>
                      </div>

                      <div id="collapseTwo" className="panel-collapse collapse">
                        <div className="payments__single-payment--panel-body">
                          {data.payStatement.bookingFeeDetails.map(fee => (
                            <div className="payments__single-payment--earnings-content">
                              <div className="payments__single-payment--first-column">
                                {`${fee.source.vehicleClass.toUpperCase()} -
                                  ${m(fee.source.startTime).format('Do MMM')} -
                                  ${m(fee.source.startTime).format('h A')} to
                                  ${m(fee.source.endTime).format('h A')}`}
                              </div>
                              <div className="payments__single-payment--second-column" />
                              <div className="payments__single-payment--third-column">{`$${fee.amount.toFixed(2) ||
                                '-'}`}</div>
                              <br />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a data-toggle="collapse" data-parent="#accordion1" href="#collapseThree">
                            Credits<span className="caret" />
                          </a>
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column">{`$${data.payStatement.creditHst.toFixed(
                          2
                        )}`}</div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.credits.toFixed(
                          2
                        )}`}</div>
                      </div>

                      <div id="collapseThree" className="panel-collapse collapse">
                        <div className="payments__single-payment--panel-body">
                          {data.payStatement.creditDetails.map(credit => (
                            <div className="payments__single-payment--earnings-content">
                              <div className="payments__single-payment--first-column">
                                {`${capitalize(credit.description)} -
                                  ${m(credit.transactionTime.replace(/\s.*/i, ''), 'YYYY-MM-DD').format('LLL')}
                            `}
                              </div>
                              <div className="payments__single-payment--second-column" />
                              <div className="payments__single-payment--third-column">{`$${credit.amount.toFixed(
                                2
                              )}`}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a data-toggle="collapse" data-parent="#accordion1" href="#collapseFour">
                            Promotions<span className="caret" />
                          </a>
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column"></div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.promos.toFixed(
                          2
                        )}`}</div>
                      </div>

                      <div id="collapseFour" className="panel-collapse collapse">
                        <div className="payments__single-payment--panel-body">
                          {data.payStatement.promoDetails.map(promo => (
                            <div className="payments__single-payment--earnings-content">
                              <div className="payments__single-payment--first-column">
                                {`${capitalize(promo.description)} -
                                  ${m(promo.transactionTime.replace(/\s.*/i, ''), 'YYYY-MM-DD').format('LLL')}
                            `}
                              </div>
                              <div className="payments__single-payment--second-column" />
                              <div className="payments__single-payment--third-column">{`$${promo.amount.toFixed(
                                2
                              )}`}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a data-toggle="collapse" data-parent="#accordion1" href="#collapseFive">
                            Deductions<span className="caret" />
                          </a>
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column">{`$${data.payStatement.deductionHst.toFixed(
                          2
                        )}`}</div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.deductions.toFixed(
                          2
                        )}`}</div>
                      </div>

                      <div id="collapseFive" className="panel-collapse collapse">
                        <div className="payments__single-payment--panel-body">
                          {data.payStatement.deductionDetails.map(deduction => (
                            <div className="payments__single-payment--earnings-content">
                              <div className="payments__single-payment--first-column">
                                {`${capitalize(deduction.description)}${
                                  /carryover/i.test(deduction.description)
                                    ? ''
                                    : ` -
                                  ${m(deduction.transactionTime.replace(/\s.*/i, ''), 'YYYY-MM-DD').format(
                                    'LLL'
                                  )}`
                                }
                            `}
                              </div>
                              <div className="payments__single-payment--second-column" />
                              <div className="payments__single-payment--third-column">{`$${deduction.amount.toFixed(
                                2
                              )}`}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {data.payStatement.viaCollections > 0 ? 
                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a>
                            Via Collections
                          </a>
                        </div>
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.viaCollections.toFixed(
                          2
                        )}`}</div>
                      </div>
                    </div> : null}
                    {data.payStatement.ccChargeDetails.length > 0 ? 
                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a data-toggle="collapse" data-parent="#accordion1" href="#collapseSix">
                            Credit Card Payments<span className="caret" />
                          </a>
                        </div>
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.ccCharges.toFixed(
                          2
                        )}`}</div>
                      </div>

                      <div id="collapseSix" className="panel-collapse collapse">
                        <div className="payments__single-payment--panel-body">
                          {data.payStatement.ccChargeDetails.map(ccCharge => (
                            <div className="payments__single-payment--earnings-content">
                              <div className="payments__single-payment--first-column">
                                {ccCharge.description}<br />{m(ccCharge.transactionTime).format('LLL')}
                              </div>
                              <div className="payments__single-payment--second-column" />
                              <div className="payments__single-payment--third-column">{`$${ccCharge.amount.toFixed(2) ||
                                '-'}`}</div>
                              <br />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div> : null}


                    {/* <div className="payments__single-payment--panel-item" style={{ borderTop: "solid 2px #ddd", paddingTop: "12px" }}>
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a>Total Owed</a>
                        </div>
                        {currentUser.operatingCity === "toronto" ?
                          <div className="payments__single-payment--second-column"></div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.totalOwed.toFixed(
                          2
                        )}`}</div>
                      </div>
                    </div>

                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--panel-item--title payments__single-payment--first-column">
                          <a>Total Paid</a>
                        </div>
                        {currentUser.operatingCity === "toronto" ?
                          <div className="payments__single-payment--second-column"></div> : null}
                        <div className="payments__single-payment--third-column">{`$${data.payStatement.totalPaid.toFixed(
                          2
                        )}`}</div>
                      </div>
                    </div> */}

                    <div className="payments__single-payment--panel-item" style={{ borderTop: "solid 2px #ddd", paddingTop: "12px" }}>
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--total payments__single-payment--panel-item--title payments__single-payment--first-column">
                          {currentUser.operatingCity === "toronto" && data.payStatement.payout > 0 ? "Total Payout" : "Statement Balance"}
                        </div>
                        {currentUser.operatingCity === "toronto" ? 
                        <div className="payments__single-payment--second-column"></div> : null}
                        <div className="payments__single-payment--total payments__single-payment--third-column">{currentUser.operatingCity === "toronto" ?  (data.payStatement.payout > 0 ? `$${data.payStatement.payout.toFixed(
                          2
                        )}` : `$${data.payStatement.balance.toFixed(2)}`) : `$${data.payStatement.balance.toFixed(2)}`}</div>
                      </div>
                    </div>
                    {m(periodStart).isAfter(m("2019-02-24")) ? 
                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--total payments__single-payment--panel-item--title payments__single-payment--first-column">
                          Previous Balance
                        </div>
                        <div className="payments__single-payment--second-column"></div>
                        <div className="payments__single-payment--total payments__single-payment--third-column">{`$${data.payStatement.broughtForward.toFixed(
                          2
                        )}`}</div>
                      </div>
                    </div> : null}
                    {currentUser.operatingCity === "toronto" && m(periodStart).isAfter(m("2019-02-24")) ? 
                    <div className="payments__single-payment--panel-item">
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--total payments__single-payment--panel-item--title payments__single-payment--first-column">
                          Paid Out
                        </div>
                        <div className="payments__single-payment--second-column"></div>
                        <div className="payments__single-payment--total payments__single-payment--third-column">{`$${data.payStatement.paidOut.toFixed(
                          2
                        )}`}</div>
                      </div>
                    </div> : null}
                    {m(periodStart).isAfter(m("2019-02-24")) ? 
                    <div className="payments__single-payment--panel-item" style={{ borderTop: "solid 2px #ddd", paddingTop: "12px" }}>
                      <div className="payments__single-payment--panel-heading">
                        <div className="payments__single-payment--total payments__single-payment--panel-item--title payments__single-payment--first-column">
                          Cumulative Balance
                        </div>
                        {currentUser.operatingCity === "toronto" ?
                          <div className="payments__single-payment--second-column"></div> : null}
                        <div className="payments__single-payment--total payments__single-payment--third-column">${data.payStatement.cumulativeBalance.toFixed(2)}</div>
                      </div>
                    </div> : null}
                    {currentUser.operatingCity === 'toronto' ? (
                      <div className="payments__single-payment--hst">Autzu HST No.: 737682328RT0001</div>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          }}
        </Query>
      </Fragment>
    );
  }
}

export default PaymentsContainer;



// WEBPACK FOOTER //
// ./src/components/NewPayments/SinglePayment.js